import React, { Component } from 'react';
import $, { event } from 'jquery';
import UserFieldsModal from './UserFieldsModal';
import config from '../config';
import { json, SERVICE_RESPONSE, decodeText } from '../libs/utils/Const';
import ApiClient from '../libs/apiClient';
import './WareHouseDetailsModal.css'
import '../css/responsive.css';
import { getFieldAccType } from '../libs/utils/Operations';
import AccountListModal from './AccountListModal';

let apiClient = ApiClient.getInstance();
class WareHouseDetailsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: false,

            /**modals */
            showUserFieldsModal: false,
            tabActive: 'General',
            orderCopy: {},
            showListAccountsModal: false,
            listAccounts: [],
            fieldUsed: '',
        }
    }

    componentDidMount() {

        this.closeAction();
    }

    closeConfirm = async () => {
        $('#wareHouseDetailsModal').modal('hide');
    }

    closeAction = () => {
        $('#wareHouseDetailsModal').on('hidden.bs.modal', function () {
        });
    };

    validateEmpty = (data) => {
        return data !== null && data !== undefined && data !== '';
    };


    validateData = () => {
        const { newOrderModel, showAlert } = this.props;

        const validations = [
            { field: newOrderModel?.WhsCode, message: 'Código de Almacén vacío', type: 'warning' },
            { field: newOrderModel?.WhsName, message: 'Nombre de Almacén vacío' },
            // { field: newOrderModel?.BalInvntAc, message: 'Agregue Cuenta de existencias', type: 'warning' },
            // { field: newOrderModel?.PriceDifAc, message: 'Agregue Cuenta de diferencias de precio', type: 'warning' },
        ];
        let isValidData = true
        for (let index = 0; index < validations.length; index++) {
            const validation = validations[index];
            if (!this.validateEmpty(validation.field ?? '')) {
                showAlert({ type: validation.type || 'error', message: validation.message });
                isValidData = false
                break;
            }
        }

        return isValidData;
    };

    continue = () => {
        const { wareHouseAction, action } = this.props
        if (!this.validateData()) return
        wareHouseAction(action)
    }
    edit = (editMode) => {

        if (editMode) {
            const { newOrderModel } = this.props;
            this.setState({ orderCopy: { ...newOrderModel } })

        } else {
            this.refreshModel(this.state.orderCopy)
        }
        this.setState({ editMode })
    }

    getTitleModal = action => {
        let title = '';
        switch (action) {
            case 'new':
                title = 'CREAR ALMACÉN'
                break;
            case 'update':
                title = 'DETALLES DE ALMACÉN'
                break;
            default:
                break;
        }
        return title
    }
    openUserFields = () => {
        this.setState({
            showUserFieldsModal: true
        }, () => {
            $('#userFieldsModal').modal('show');
        })

    };

    renderSelector = () => {
        return (
            <div className='d-flex justify-content-end align-items-center' >
                <label
                    id='UserFieldsLbl'
                    className="font-weight-bold mb-0 mr-3">
                    <span className="d-none d-xl-inline">Campos de Usuario</span>
                    <span className="d-inline d-xl-none">Campos Usuario</span>
                </label>
                <button
                    id='UserFieldsBtn'
                    type="button"
                    style={{
                        backgroundColor: 'transparent',
                        color: '#EABF28',
                    }}
                    className="btn p-0"
                    onClick={this.openUserFields}>
                    <i className="fa fa-list" aria-hidden="true" />
                </button>
            </div>
        )
    }

    hanldeUserFields = async (index, event) => {
        const { showAlert, enableSpinner, newOrderModel, view } = this.props;
        let newView = newOrderModel.newView || view;


        this.setState({
            newOrderModel,
        });
    }

    refreshModel = newOrderModel => {
        const { refreshModel } = this.props;
        refreshModel(newOrderModel);
    };
    /**COMPONENTS */
    renderCheckBox = (property, checked, label, idLbnl, idCheck, action) => {

        const disabled = this.disableEdition(property)
        return (
            <div className="input-group mb-3 align-items-center">
                <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold" id={idLbnl}>
                        {label}
                    </span>
                </div>

                <div
                    className="form-control d-flex align-items-center justify-content-center formcont-responsive"
                    style={{ minHeight: '38px' }}
                >
                    <input
                        disabled={disabled}
                        type="checkbox"
                        id={idCheck}
                        checked={checked}
                        style={{ width: '18px', height: '18px' }}
                        onChange={(e) => this.handleOnChange(property, e.target.checked ? 'Y' : 'N')}
                    />
                </div>
            </div>
        )
    }
    renderSelect = (property, value, label, options) => {
        const disabled = this.disableEdition(property)
        return (
            <div className="input-group mb-3 align-items-center">
                <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold">
                        {label}
                    </span>
                </div>

                <select
                    disabled={disabled}
                    onChange={(e) => this.handleOnChange(property, e.target.value)}
                    value={value}
                    className="form-control">
                    {options.map(op => (
                        <option key={op.value} value={op.value}>
                            {op.label}
                        </option>
                    ))}
                </select>
            </div>

        )
    }
    disableEdition = property => {
        const { action } = this.props
        const { editMode } = this.state
        let isDisabled = (!editMode && action === 'update')
        switch (property) {
            case 'WhsCode':
                isDisabled = (action === 'update' && !editMode) || !(action === 'new')
                break;

            default:
                break;
        }
        return isDisabled
    }
    renderInput = (property, value, label, title = '', btnAction = null) => {

        const disableInput = this.disableEdition(property)
        return (
            <div title={title || ''} className="input-group mb-3 align-items-center">
                {label != '' && <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold">
                        {label}
                    </span>
                </div>
                }

                <input
                    disabled={disableInput}
                    type="text"
                    className="form-control input-sm"
                    id="dynInput"
                    value={value}
                    onChange={(e) => this.handleOnChange(property, e.target.value)}
                />
                {btnAction &&

                    <div className="input-group-append">
                        <button
                            type="button"
                            className="input-group-text"
                            style={{
                                width: '40px',
                                height: '38px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'transparent',
                                color: '#EABF28',
                                border: '1px solid #ced4da',
                                borderLeft: 'none'
                            }}
                            onClick={btnAction}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                    </div>
                }
            </div>

        )
    }
    /**END COMPONENTS */
    checkValue = val => {
        let checked = false
        if (val === 'Y') {
            checked = true
        }
        return checked
    }

    handleOnChange = (property, value) => {
        const { newOrderModel, refreshModel } = this.props

        if (this.disableEdition(property)) return

        const auxModel = { ...newOrderModel }

        auxModel[property] = value
        refreshModel(auxModel)
    }

    listAccount = async (field) => {

        const { enableSpinner, showAlert, newOrderModel } = this.props
        const data = {
            Search: newOrderModel[field],
            AccType: getFieldAccType(field)
        }
        enableSpinner(true);
        const list = await apiClient.listAccounts(data);
        enableSpinner(false);
        if (list.status === SERVICE_RESPONSE.SUCCESS) {
            if (list?.data?.length === 1 ?? false) {
                this.handleOnChange(field, list?.data?.[0].AcctCode)
            } else {
                this.setState({
                    listAccounts: list?.data || [],
                    showListAccountsModal: true,
                    fieldUsed: field

                }, () => {
                    $('#AccountListModal').modal('show');
                })
            }
        } else {
            showAlert({ type: 'error', message: list.message })
        }
    }
    renderGeneralTab = () => {
        const { newOrderModel } = this.props
        return (
            <div
                className='mt-3'
                id='General'
                style={{
                    height: '500px'
                    , maxHeight: '500px'
                    , overflowY: 'auto'
                    , overflowX: 'hidden'
                    , scrollbarWidth: 'thin'
                    , scrollbarColor: '#c1c1c1 #f1f1f1'
                }}
            >
                <div className='row w-100 justify-content-between'>
                    <div className='col-12 col-lg-3'>
                        {this.renderCheckBox('Inactive', this.checkValue(newOrderModel?.Inactive || ''), 'Inactivo', 'WhsInactiveLbl', 'WhsInactivechbx',)}
                    </div>
                    <div className='col-12 col-lg-3'>
                        {this.renderCheckBox('DropShip', this.checkValue(newOrderModel?.DropShip || ''), 'Envío directo', 'DropShipLbl', 'DropShipchbx',)}
                    </div>
                    <div className='col-12 col-lg-3'>
                        {this.renderCheckBox('Nettable', this.checkValue(newOrderModel?.Nettable || ''), 'Tabla neta', 'NetTableLbl', 'NetTablechbx',)}
                    </div>
                    <div className='col-12 col-lg-3'>
                        {this.renderCheckBox('BinActivat', this.checkValue(newOrderModel?.BinActivat || ''), 'Activar Ubicaciones', 'BinActivatLbl', 'BinActivatchbx',)}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-lg-6'>
                        {this.renderSelect('Location', newOrderModel?.Location || '', 'Localidad', [])}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12 col-lg-6'>
                        {this.renderInput('Street', newOrderModel?.Street || '', 'Calle', 'Calle / Apartado de correos')}
                        {this.renderInput('StreetNo', newOrderModel?.StreetNo || '', 'Num. Calle', 'Número de la calle')}
                        {this.renderInput('Block', newOrderModel?.Block || '', 'Bloquear', 'Bloquear')}
                        {this.renderInput('Building', newOrderModel?.Building || '', 'Edificio/Planta/Sala', 'Edificio/Planta/Sala')}
                        {this.renderInput('ZipCode', newOrderModel?.ZipCode || '', 'C.P.', 'Código Postal')}
                        {this.renderInput('City', newOrderModel?.City || '', 'Ciudad', 'Ciudad')}
                        {this.renderInput('County', newOrderModel?.County || '', 'Condado', 'Condado')}
                    </div>
                    <div className='col-12 col-lg-6'>
                        {this.renderSelect('Country', newOrderModel?.Country || '', 'País', [])}
                        {this.renderSelect('State', newOrderModel?.State || '', 'Estado', [])}
                        {this.renderInput('FedTaxID', newOrderModel?.FedTaxID || '', 'RFC', 'Identificación fiscal federal')}
                        {this.renderInput('GlblLocNum', newOrderModel?.GlblLocNum || '', 'GLN', 'GLN')}
                        {this.renderInput('TaxOffice', newOrderModel?.TaxOffice || '', 'Hacienda', 'Hacienda')}
                        {this.renderInput('Address2', newOrderModel?.Address2 || '', 'Dir. 2', 'Nombre de la dirección 2')}
                        {this.renderInput('Address3', newOrderModel?.Address3 || '', 'Dir. 3', 'Nombre de la dirección 3')}
                    </div>
                </div>
            </div>
        )
    }
    renderFinancialTab = () => {
        const { newOrderModel } = this.props
        return (
            <div
                className='mt-3'
                id='Financial'
                style={{
                    height: '500px'
                    , maxHeight: '500px'
                    , overflowY: 'auto'
                    , overflowX: 'hidden'
                    , scrollbarWidth: 'thin'
                    , scrollbarColor: '#c1c1c1 #f1f1f1'
                }}
            >

                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        {this.renderInput('ExpensesAc', newOrderModel?.ExpensesAc || '', 'Cta. gastos', 'Cuenta de gastos', () => { this.listAccount('ExpensesAc') })}
                        {this.renderInput('RevenuesAc', newOrderModel?.RevenuesAc || '', 'Cta. ingresos', 'Cuenta de ingresos', () => { this.listAccount('RevenuesAc') })}
                        {this.renderInput('BalInvntAc', newOrderModel?.BalInvntAc || '', 'Cta. existencias', 'Cuenta de existencias', () => { this.listAccount('BalInvntAc') })}
                        {this.renderInput('SaleCostAc', newOrderModel?.SaleCostAc || '', 'Cta. costo de bienes ven.', 'Cuenta de costo de bienes vendidos', () => { this.listAccount('SaleCostAc') })}
                        {this.renderInput('TransferAc', newOrderModel?.TransferAc || '', 'Cta. dotación', 'Cuenta de dotación', () => { this.listAccount('TransferAc') })}
                        {this.renderInput('VarianceAc', newOrderModel?.VarianceAc || '', 'Cta. desviación', 'Cuenta de desviación', () => { this.listAccount('VarianceAc') })}
                        {this.renderInput('PriceDifAc', newOrderModel?.PriceDifAc || '', 'Cta. dif. precio', 'Cuenta de diferencias de precio', () => { this.listAccount('PriceDifAc') })}
                        {this.renderInput('NegStckAct', newOrderModel?.NegStckAct || '', 'Cta. ajuste de stock neg.', 'Cuenta de ajuste de stock negativo', () => { this.listAccount('NegStckAct') })}
                        {this.renderInput('DecreasAc', newOrderModel?.DecreasAc || '', 'Comp. stocks - Cta. reducción', 'Compensación de stocks - Cuenta de reducción', () => { this.listAccount('DecreasAc') })}
                        {this.renderInput('IncreasAc', newOrderModel?.IncreasAc || '', 'Comp. stocks - Cta. aumento', 'Compensación de stocks - Cuenta de aumento', () => { this.listAccount('IncreasAc') })}
                        {this.renderInput('ReturnAc', newOrderModel?.ReturnAc || '', 'Cta. devoluciones por ventas', 'Cuenta de devoluciones por ventas', () => { this.listAccount('ReturnAc') })}
                        {this.renderInput('FrRevenuAc', newOrderModel?.FrRevenuAc || '', 'Cta. ingresos - Extranjero', 'Cuenta de ingresos - Extranjero', () => { this.listAccount('FrRevenuAc') })}
                        {this.renderInput('FrExpensAc', newOrderModel?.FrExpensAc || '', 'Cta. costos - Extranjero', 'Cuenta de costos - Extranjero', () => { this.listAccount('FrExpensAc') })}
                        {this.renderInput('ExchangeAc', newOrderModel?.ExchangeAc || '', 'Cta. dif. tipo de cambio', 'Cuenta de diferencias de tipo de cambio', () => { this.listAccount('ExchangeAc') })}
                        {this.renderInput('BalanceAcc', newOrderModel?.BalanceAcc || '', 'Cuenta comp. mercancías', 'Cuenta compensación mercancías', () => { this.listAccount('BalanceAcc') })}
                        {this.renderInput('DecresGlAc', newOrderModel?.DecresGlAc || '', 'Cta. reducción del libro mayor', 'Cuenta de reducción del libro mayor', () => { this.listAccount('DecresGlAc') })}


                    </div>
                    <div className='col-12 col-xl-6'>

                        {this.renderInput('IncresGlAc', newOrderModel?.IncresGlAc || '', 'Cta. aumento del libro mayor', 'Cuenta de aumento del libro mayor', () => { this.listAccount('IncresGlAc') })}
                        {this.renderInput('WipAcct', newOrderModel?.WipAcct || '', 'Cta. stocks trabajo curso', 'Cuenta de stocks de trabajo en curso', () => { this.listAccount('WipAcct') })}
                        {this.renderInput('WipVarAcct', newOrderModel?.WipVarAcct || '', 'Cta. desviación de stock WIP', 'Cuenta de desviación de stock WIP', () => { this.listAccount('WipVarAcct') })}
                        {this.renderInput('WipOffset', newOrderModel?.WipOffset || '', 'Cta. PyG de comp. WIP', 'Cuenta PyG de compensación WIP', () => { this.listAccount('WipOffset') })}
                        {this.renderInput('StockOffst', newOrderModel?.StockOffst || '', 'Cta. PyG de comp. de stocks', 'Cuenta PyG de compensación de stocks', () => { this.listAccount('StockOffst') })}
                        {this.renderInput('StokRvlAct', newOrderModel?.StokRvlAct || '', 'Cta. de revalorización de stocks', 'Cuenta de revalorización de stocks', () => { this.listAccount('StokRvlAct') })}
                        {this.renderInput('StkOffsAct', newOrderModel?.StkOffsAct || '', 'Cta. contrapartida de rev. inventario', 'Cuenta de contrapartida de la revalorización del inventario', () => { this.listAccount('StkOffsAct') })}
                        {this.renderInput('CostRvlAct', newOrderModel?.CostRvlAct || '', 'Cta. revaloración precio costo', 'Cuenta revaloración precio costo', () => { this.listAccount('CostRvlAct') })}
                        {this.renderInput('CstOffsAct', newOrderModel?.CstOffsAct || '', 'Rev. precio de costo - Cta. contrapartida', 'Revaloración precio de costo - Cuenta de contrapartida', () => { this.listAccount('CstOffsAct') })}
                        {this.renderInput('ExpClrAct', newOrderModel?.ExpClrAct || '', 'Cta. comp. gastos', 'Cuenta compensación gastos', () => { this.listAccount('ExpClrAct') })}
                        {this.renderInput('StkInTnAct', newOrderModel?.StkInTnAct || '', 'Stock en cta. tránsito', 'Stock en la cuenta de tránsito', () => { this.listAccount('StkInTnAct') })}
                        {this.renderInput('ShpdGdsAct', newOrderModel?.ShpdGdsAct || '', 'Cta. mercancías enviadas', 'Cuenta de mercancías enviadas', () => { this.listAccount('ShpdGdsAct') })}
                        {this.renderInput('ARCMAct', newOrderModel?.ARCMAct || '', 'Cta.crédito ventas', 'Cta.crédito ventas', () => { this.listAccount('ARCMAct') })}
                        {this.renderInput('APCMAct', newOrderModel?.APCMAct || '', 'Cta.crédito compras', 'Cta.crédito compras', () => { this.listAccount('APCMAct') })}
                        {this.renderInput('ARCMFrnAct', newOrderModel?.ARCMFrnAct || '', 'Cta.crédito ventas: Extranjero', 'Cta.crédito ventas: Extranjero', () => { this.listAccount('ARCMFrnAct') })}
                        {this.renderInput('APCMFrnAct', newOrderModel?.APCMFrnAct || '', 'Cta.crédito compras - Extranjero', 'Cta.crédito compras - Extranjero', () => { this.listAccount('APCMFrnAct') })}


                    </div>
                </div>
                <hr style={{ borderTop: '1px solid #dee2e6', width: '100%' }} />
                <div className='row mt-4'>

                    <div className='col-12 col-xl-6'>

                        {this.renderInput('TaxOffice', newOrderModel?.TaxOffice || '', 'Hacienda', 'Hacienda')}
                        {this.renderInput('Address2', newOrderModel?.Address2 || '', 'Dir. 2', 'Nombre de la dirección 2')}
                        {this.renderInput('Address3', newOrderModel?.Address3 || '', 'Dir. 3', 'Nombre de la dirección 3')}
                    </div>
                </div>
            </div>
        )
    }

    renderTabContent = () => {
        const { tabActive } = this.state
        switch (tabActive) {
            case 'General':
                return this.renderGeneralTab();
            case 'Financial':
                return this.renderFinancialTab();
            default:
                return <></>
        }
    }

    renderTabsTitle = () => {
        const { tabActive } = this.state
        return (
            <ul
                id='WhsDetailsTabs'
                className='nav nav-tabs'>
                <li className='nav-item'>
                    <a
                        className={`nav-link ${tabActive === 'General' ? 'active' : ''}`}
                        href='#General'
                        aria-current="page"
                        onClick={() => this.setState({ tabActive: 'General' })}
                    >General</a>
                </li>
                {/* <li className='nav-item'>
                    <a
                        className={`nav-link ${tabActive === 'Financial' ? 'active' : ''}`}
                        href='#Financial'
                        aria-current="page"
                        onClick={() => this.setState({ tabActive: 'Financial' })}
                    >Finanzas</a>
                </li> */}
            </ul>
        )
    }
    selectAccountList = indexAcc => {
        const { listAccounts } = this.state
        if (listAccounts[indexAcc.index].AcctCode) {
            $('#AccountListModal').modal('hide');
            this.handleOnChange(this.state.fieldUsed, listAccounts[indexAcc.index].AcctCode)
            this.setState({
                listAccounts: [],
                showListAccountsModal: false,
                fieldUsed: ''
            }, () => {

            })
        }

    }
    render() {
        const { action, newOrderModel, view, configHeaderUserFields, openConfigUserFieldsHeaders } = this.props
        const {
            editMode
            , showUserFieldsModal
            , showListAccountsModal
            , listAccounts
        } = this.state
        return (
            <div
                className="modal fade bd-example-modal-xl modal-open scroll"
                id="wareHouseDetailsModal"
                role="dialog"
                data-backdrop="static"
                data-keyboard="false"

                style={{ zIndex: 90 }}
            >
                {showListAccountsModal &&
                    <AccountListModal
                        data={listAccounts}
                        selectAccount={this.selectAccountList}
                        cleanData={() => this.setState({ listAccounts: [], showListAccountsModal: false, fieldUsed: '' })}

                    />
                }
                {showUserFieldsModal && <UserFieldsModal
                    newOrderModel={newOrderModel}
                    action={action === 'new' ? 1 : 2}
                    refreshModel={this.refreshModel}
                    view={view}
                    hanldeUserFields={this.hanldeUserFields}
                    newView={newOrderModel.newView}
                    editMode={!this.disableEdition('')}
                    openConfigUserFieldsHeaders={openConfigUserFieldsHeaders}
                    configHeaderUserFields={configHeaderUserFields}

                />
                }
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {this.getTitleModal(action)}
                            </h4>
                            <button type="button" className="close" onClick={this.closeConfirm} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        {this.renderSelector()}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className='row'>
                                            <div className='col-12 col-lg-6'>
                                                {this.renderInput('WhsCode', newOrderModel?.WhsCode || '', 'Cod. Alm.', 'Código de Almacén')}

                                            </div>
                                            <div className='col-12 col-lg-6'>
                                                {this.renderInput('WhsName', decodeText(newOrderModel?.WhsName) || '', 'Nombre Alm.', 'Nombre de Almacén')}

                                            </div>


                                        </div>

                                        {this.renderTabsTitle()}

                                        <div className="tab-content">
                                            {this.renderTabContent()}
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn botonCorrect text-black" onClick={!editMode && action != 'new' ? () => this.edit(true) : this.continue}> {action === 'new' ? 'Crear' : editMode ? 'Guardar' : 'Editar'}  </button>
                            {editMode &&
                                <button
                                    type="button"
                                    className="btn text-black btnCancel"
                                    style={{ border: '1px solid #EABF28 ', borderRadius: '5px' }}
                                    onClick={() => this.edit(false)}> Cancelar </button>
                            }
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeConfirm}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
export default WareHouseDetailsModal;